export default "__VITE_ASSET__bc980d92__"